export const RFIS_COUNT = 'RFIS_COUNT';
export const RFIS_LOAD = 'RFIS_LOAD';
